// TODO: Master list
// - [Mateo] Need images in components
// - [Mateo] Need images in upsell components
// - [Mateo] need boot names updated (performance vs. basic)
// - [Mateo] need to fill out metafield for show FitFinder
// - [Mateo] Have all all select values in the final field be structured "Mondo 25.5 (US 8 - 8.5)"
// - [Mateo] Add upsell for basic boot?
// - [Mateo] Add upsell for the works?

// - [Elad/Matt] Documentation
// - [Elad] confirm names of kids' shoe sizes are correct

// --- GLOBALS --------------------------------------------------------------------------
const openButton = $('a[data-target="fit-finder-modal"]')
const modal = $('#fit-finder-modal');
const modalBody = modal.find('.modal-body');
const modalSlideContent = modalBody.find('#slide-content');
const [modalSlideTitle] = modalSlideContent.find('#slide-content--title');
const modalSlideSubtitle = modalSlideContent.find('#slide-content--subtitle');
const modalNavBack = modalBody.find('#bottom-row-nav button[data-nav="back"]');
const modalNavContinue = modalBody.find('#bottom-row-nav button[data-nav="continue"]');
const modalNavAddMySize = modalBody.find('#bottom-row-nav button[data-nav="add-my-size"]');
const modalNavDone = modalBody.find('#bottom-row-nav button[data-nav="done"]');
const modalNavRow2 = modalBody.find('#bottom-row-nav-2');
const modalNavAddMySizeBasicOnly = modalBody.find('#bottom-row-nav-2 button[data-nav="add-my-size-basic-only"]');

const defaultSelectors = $('.rental-component select').filter((i, e) => e.name && e.name.toLowerCase().includes('boot'));
const [defaultSelector] = defaultSelectors.length > 1 ? defaultSelectors.filter((i, e) => e.name && (e.name.toLowerCase().includes('ski') || e.name.toLowerCase().includes('basic') || e.name.toLowerCase().includes('performance'))) : defaultSelectors;

const [bootAddonTile] = $('.rental-addon-tile').filter((i, e) => e.dataset?.productHandle?.toLowerCase().includes('performance') && e.dataset?.productHandle?.toLowerCase().includes('boot'));
const [addonSelector] = $(bootAddonTile).find('.rental-addon-tile--select');
const [addonButton] = $(bootAddonTile).find('.rental-addon-tile--button');
const [addonPrice] = $(bootAddonTile).find('.rental-addon-tile--price');
const modalNavAddMySizeText = modalNavAddMySize.text();

const maxSlides = 4;
const gender = product.tags.find(e => e.toLowerCase().includes('gender'))?.split(':')[1].replace("'", '').toLowerCase();
const bootComponents = product.components.filter(e => e.name.toLowerCase().includes('boot'));
const bootComponent = bootComponents.length > 1 ? bootComponents.find(e => e.name.toLowerCase().includes('ski') || e.name.toLowerCase().includes('basic') || e.name.toLowerCase().includes('performance')) : bootComponents[0];
const addonBoot = bootComponent?.upsells?.find(e => e.name.toLowerCase().includes('boot'));

const hasAddon = Boolean(addonBoot);
let defaultBootType = bootComponent?.name.toLowerCase().replace('boot', '').trim(); //"basic" or "performance"
const image = {
  basic: '',
  performance: '',
}

if (defaultBootType !== 'performance' && defaultBootType !== 'basic') defaultBootType = 'basic'; // in case of empty string
image[defaultBootType] = bootComponent?.image ? bootComponent.image[0].src : '';
if (hasAddon) image.performance = addonBoot?.image ? addonBoot.image[0].src : '';

const shoeSizeOptions = {
  mens: [
    { name: "Men's US 7", value: 7 },
    { name: "Men's US 7.5", value: 7.5 },
    { name: "Men's US 8", value: 8 },
    { name: "Men's US 8.5", value: 8.5 },
    { name: "Men's US 9", value: 9 },
    { name: "Men's US 9.5", value: 9.5 },
    { name: "Men's US 10", value: 10 },
    { name: "Men's US 10.5", value: 10.5 },
    { name: "Men's US 11", value: 11 },
    { name: "Men's US 11.5", value: 11.5 },
    { name: "Men's US 12", value: 12 },
    { name: "Men's US 12.5", value: 12.5 },
    { name: "Men's US 13", value: 13 },
    { name: "Men's US 13.5", value: 13.5 },
    { name: "Men's US 14", value: 14 },
    { name: "Men's US 14.5", value: 14.5 },
    { name: "Men's US 15", value: 15 },
    { name: "Men's US 15.5", value: 15.5 },
    { name: "Men's US 16", value: 16 }
  ],
  womens: [
    { name: "Women's US 5", value: 5 },
    { name: "Women's US 5.5", value: 5.5 },
    { name: "Women's US 6", value: 6 },
    { name: "Women's US 6.5", value: 6.5 },
    { name: "Women's US 7", value: 7 },
    { name: "Women's US 7.5", value: 7.5 },
    { name: "Women's US 8", value: 8 },
    { name: "Women's US 8.5", value: 8.5 },
    { name: "Women's US 9", value: 9 },
    { name: "Women's US 9.5", value: 9.5 },
    { name: "Women's US 10", value: 10 },
    { name: "Women's US 10.5", value: 10.5 },
    { name: "Women's US 11", value: 11 },
    { name: "Women's US 11.5", value: 11.5 },
    { name: "Women's US 12", value: 12 }
  ],
  junior: [
    { name: "Little Kids US 8", value: 8-13 },
    { name: "Little Kids US 8.5", value: 8.5-13 },
    { name: "Little Kids US 9", value: 9-13 },
    { name: "Little Kids US 9.5", value: 9.5-13 },
    { name: "Little Kids US 10", value: 10-13 },
    { name: "Little Kids US 10.5", value: 10.5-13 },
    { name: "Little Kids US 11", value: 11-13 },
    { name: "Little Kids US 11.5", value: 11.5-13 },
    { name: "Little Kids US 12", value: 12-13 },
    { name: "Little Kids US 12.5", value: 12.5-13 },
    { name: "Little Kids US 13", value: 13-13 },
    { name: "Little Kids US 13.5", value: 13.5-13 },
    { name: "Junior US 1", value: 1 },
    { name: "Junior US 1.5", value: 1.5 },
    { name: "Junior US 2", value: 2 },
    { name: "Junior US 2.5", value: 2.5 },
    { name: "Junior US 3", value: 3 },
    { name: "Junior US 3.5", value: 3.5 },
    { name: "Junior US 4", value: 4 },
    { name: "Junior US 4.5", value: 4.5 },
    { name: "Junior US 5", value: 5 },
    { name: "Junior US 5.5", value: 5.5 },
    { name: "Junior US 6", value: 6 },
    { name: "Junior US 6.5", value: 6.5 },
    { name: "Junior US 7", value: 7 },
    { name: "Junior US 7.5", value: 7.5 },
    { name: "Junior US 8", value: 8 },
    { name: "Junior US 8.5", value: 8.5 }
  ],
}

const sizingChart = {
  mens: [
    {
      inches: { min: 9.25, max: 9.44 },
      mondo: { beginner: 25.5, advanced: 24.5 },
      shoe: 7
    },
    {
      inches: { min: 9.44, max: 9.64 },
      mondo: { beginner: 25.5, advanced: 24.5 },
      shoe: 7.5
    },
    {
      inches: { min: 9.64, max: 9.84 },
      mondo: { beginner: 26.5, advanced: 25.5 },
      shoe: 8
    },
    {
      inches: { min: 9.84, max: 10.03 },
      mondo: { beginner: 26.5, advanced: 25.5 },
      shoe: 8.5
    },
    {
      inches: { min: 10.03, max: 10.23 },
      mondo: { beginner: 27.5, advanced: 26.5 },
      shoe: 9
    },
    {
      inches: { min: 10.23, max: 10.43 },
      mondo: { beginner: 27.5, advanced: 26.5 },
      shoe: 9.5
    },
    {
      inches: { min: 10.43, max: 10.62 },
      mondo: { beginner: 28.5, advanced: 27.5 },
      shoe: 10
    },
    {
      inches: { min: 10.62, max: 10.82 },
      mondo: { beginner: 28.5, advanced: 27.5 },
      shoe: 10.5
    },
    {
      inches: { min: 10.82, max: 11.02 },
      mondo: { beginner: 29.5, advanced: 28.5 },
      shoe: 11
    },
    {
      inches: { min: 11.02, max: 11.22 },
      mondo: { beginner: 29.5, advanced: 28.5 },
      shoe: 11.5
    },
    {
      inches: { min: 11.22, max: 11.41 },
      mondo: { beginner: 30.5, advanced: 29.5 },
      shoe: 12
    },
    {
      inches: { min: 11.41, max: 11.61 },
      mondo: { beginner: 30.5, advanced: 29.5 },
      shoe: 12.5
    },
    {
      inches: { min: 11.61, max: 11.81 },
      mondo: { beginner: 31.5, advanced: 30.5 },
      shoe: 13
    },
    {
      inches: { min: 11.81, max: 12 },
      mondo: { beginner: 31.5, advanced: 30.5 },
      shoe: 13.5
    },
    {
      inches: { min: 12, max: 12.2 },
      mondo: { beginner: 32.5, advanced: 31.5 },
      shoe: 14
    },
    {
      inches: { min: 12.2, max: 12.4 },
      mondo: { beginner: 32.5, advanced: 31.5 },
      shoe: 14.5
    },
    {
      inches: { min: 12.4, max: 12.59 },
      mondo: { beginner: 33.5, advanced: 32.5 },
      shoe: 15
    },
    {
      inches: { min: 12.59, max: 12.79 },
      mondo: { beginner: 33.5, advanced: 32.5 },
      shoe: 15.5
    },
    {
      inches: { min: 12.79, max: 13 },
      mondo: { beginner: 33.5, advanced: 33.5 },
      shoe: 16
    }
  ],
  womens: [
    {
      inches: { min: 8.07, max: 8.26 },
      mondo: { beginner: 22.5, advanced: 21.5 },
      shoe: 5
    },
    {
      inches: { min: 8.26, max: 8.46 },
      mondo: { beginner: 22.5, advanced: 21.5 },
      shoe: 5.5
    },
    {
      inches: { min: 8.46, max: 8.66 },
      mondo: { beginner: 23.5, advanced: 22.5 },
      shoe: 6
    },
    {
      inches: { min: 8.66, max: 8.85 },
      mondo: { beginner: 23.5, advanced: 22.5 },
      shoe: 6.5
    },
    {
      inches: { min: 8.85, max: 9.05 },
      mondo: { beginner: 24.5, advanced: 23.5 },
      shoe: 7
    },
    {
      inches: { min: 9.05, max: 9.25 },
      mondo: { beginner: 24.5, advanced: 23.5 },
      shoe: 7.5
    },
    {
      inches: { min: 9.25, max: 9.44 },
      mondo: { beginner: 25.5, advanced: 24.5 },
      shoe: 8
    },
    {
      inches: { min: 9.44, max: 9.64 },
      mondo: { beginner: 25.5, advanced: 24.5 },
      shoe: 8.5
    },
    {
      inches: { min: 9.64, max: 9.84 },
      mondo: { beginner: 26.5, advanced: 25.5 },
      shoe: 9
    },
    {
      inches: { min: 9.84, max: 10.03 },
      mondo: { beginner: 26.5, advanced: 25.5 },
      shoe: 9.5
    },
    {
      inches: { min: 10.03, max: 10.23 },
      mondo: { beginner: 27.5, advanced: 26.5 },
      shoe: 10
    },
    {
      inches: { min: 10.23, max: 10.43 },
      mondo: { beginner: 27.5, advanced: 26.5 },
      shoe: 10.5
    },
    {
      inches: { min: 10.43, max: 10.62 },
      mondo: { beginner: 28.5, advanced: 27.5 },
      shoe: 11
    },
    {
      inches: { min: 10.62, max: 10.82 },
      mondo: { beginner: 28.5, advanced: 27.5 },
      shoe: 11.5
    },
    {
      inches: { min: 10.82, max: 11.02 },
      mondo: { beginner: 29.5, advanced: 28.5 },
      shoe: 12
    }
  ],
  junior: [
    {
      inches: { min: 5.71, max: 6.1 },
      mondo: { beginner: 15.5, advanced: null },
      shoe: -5
    },
    {
      inches: { min: 6.1, max: 6.49 },
      mondo: { beginner: 16.5, advanced: null },
      shoe: -4
    },
    {
      inches: { min: 6.49, max: 6.69 },
      mondo: { beginner: 17.5, advanced: null },
      shoe: -3
    },
    {
      inches: { min: 6.69, max: 6.88 },
      mondo: { beginner: 17.5, advanced: null },
      shoe: -2
    },
    {
      inches: { min: 6.88, max: 7.08 },
      mondo: { beginner: 18.5, advanced: null },
      shoe: -1
    },
    {
      inches: { min: 7.08, max: 7.28 },
      mondo: { beginner: 19.5, advanced: null },
      shoe: 0
    },
    {
      inches: { min: 7.28, max: 7.48 },
      mondo: { beginner: 20.5, advanced: null },
      shoe: 0.5
    },
    {
      inches: { min: 7.48, max: 7.67 },
      mondo: { beginner: 20.5, advanced: null },
      shoe: 1
    },
    {
      inches: { min: 7.67, max: 7.87 },
      mondo: { beginner: 21.5, advanced: null },
      shoe: 2
    },
    {
      inches: { min: 7.87, max: 8.07 },
      mondo: { beginner: 21.5, advanced: null },
      shoe: 3
    },
    {
      inches: { min: 8.07, max: 8.26 },
      mondo: { beginner: 22.5, advanced: 21.5 },
      shoe: 4
    },
    {
      inches: { min: 8.26, max: 8.46 },
      mondo: { beginner: 22.5, advanced: 21.5 },
      shoe: 4.5
    },
    {
      inches: { min: 8.46, max: 8.66 },
      mondo: { beginner: 23.5, advanced: 22.5 },
      shoe: 5
    },
    {
      inches: { min: 8.66, max: 8.85 },
      mondo: { beginner: 23.5, advanced: 22.5 },
      shoe: 5.5
    },
    {
      inches: { min: 8.85, max: 9.05 },
      mondo: { beginner: 24.5, advanced: 23.5 },
      shoe: 6
    },
    {
      inches: { min: 9.05, max: 9.25 },
      mondo: { beginner: 24.5, advanced: 23.5 },
      shoe: 6.5
    },
    {
      inches: { min: 9.25, max: 9.44 },
      mondo: { beginner: 25.5, advanced: 24.5 },
      shoe: 7
    },
    {
      inches: { min: 9.44, max: 9.64 },
      mondo: { beginner: 25.5, advanced: 24.5 },
      shoe: 7.5
    },
    {
      inches: { min: 9.64, max: 9.84 },
      mondo: { beginner: 26.5, advanced: 25.5 },
      shoe: 8
    },
    {
      inches: { min: 9.84, max: 10.03 },
      mondo: { beginner: 26.5, advanced: 25.5 },
      shoe: 8.5
    }
  ],
  all: [
    {
      inches: { min: 5.71, max: 6.1 },
      mondo: { beginner: 15.5, advanced: null }
    },
    {
      inches: { min: 6.1, max: 6.49 },
      mondo: { beginner: 16.5, advanced: null }
    },
    {
      inches: { min: 6.49, max: 6.69 },
      mondo: { beginner: 17.5, advanced: null }
    },
    {
      inches: { min: 6.69, max: 6.88 },
      mondo: { beginner: 17.5, advanced: null }
    },
    {
      inches: { min: 6.88, max: 7.08 },
      mondo: { beginner: 18.5, advanced: null }
    },
    {
      inches: { min: 7.08, max: 7.28 },
      mondo: { beginner: 19.5, advanced: null }
    },
    {
      inches: { min: 7.28, max: 7.48 },
      mondo: { beginner: 20.5, advanced: null }
    },
    {
      inches: { min: 7.48, max: 7.67 },
      mondo: { beginner: 20.5, advanced: null }
    },
    {
      inches: { min: 7.67, max: 7.87 },
      mondo: { beginner: 21.5, advanced: null }
    },
    {
      inches: { min: 7.87, max: 8.07 },
      mondo: { beginner: 21.5, advanced: null }
    },
    {
      inches: { min: 8.07, max: 8.26 },
      mondo: { beginner: 22.5, advanced: 21.5 }
    },
    {
      inches: { min: 8.26, max: 8.46 },
      mondo: { beginner: 22.5, advanced: 21.5 }
    },
    {
      inches: { min: 8.46, max: 8.66 },
      mondo: { beginner: 23.5, advanced: 22.5 }
    },
    {
      inches: { min: 8.66, max: 8.85 },
      mondo: { beginner: 23.5, advanced: 22.5 }
    },
    {
      inches: { min: 8.85, max: 9.05 },
      mondo: { beginner: 24.5, advanced: 23.5 }
    },
    {
      inches: { min: 9.05, max: 9.25 },
      mondo: { beginner: 24.5, advanced: 23.5 }
    },
    {
      inches: { min: 9.25, max: 9.44 },
      mondo: { beginner: 25.5, advanced: 24.5 }
    },
    {
      inches: { min: 9.44, max: 9.64 },
      mondo: { beginner: 25.5, advanced: 24.5 }
    },
    {
      inches: { min: 9.64, max: 9.84 },
      mondo: { beginner: 26.5, advanced: 25.5 }
    },
    {
      inches: { min: 9.84, max: 10.03 },
      mondo: { beginner: 26.5, advanced: 25.5 }
    },
    {
      inches: { min: 10.03, max: 10.23 },
      mondo: { beginner: 27.5, advanced: 26.5 }
    },
    {
      inches: { min: 10.23, max: 10.43 },
      mondo: { beginner: 27.5, advanced: 26.5 }
    },
    {
      inches: { min: 10.43, max: 10.62 },
      mondo: { beginner: 28.5, advanced: 27.5 }
    },
    {
      inches: { min: 10.62, max: 10.82 },
      mondo: { beginner: 28.5, advanced: 27.5 }
    },
    {
      inches: { min: 10.82, max: 11.02 },
      mondo: { beginner: 29.5, advanced: 28.5 }
    },
    {
      inches: { min: 11.02, max: 11.22 },
      mondo: { beginner: 29.5, advanced: 28.5 }
    },
    {
      inches: { min: 11.22, max: 11.41 },
      mondo: { beginner: 30.5, advanced: 29.5 }
    },
    {
      inches: { min: 11.41, max: 11.61 },
      mondo: { beginner: 30.5, advanced: 29.5 }
    },
    {
      inches: { min: 11.61, max: 11.81 },
      mondo: { beginner: 31.5, advanced: 30.5 }
    },
    {
      inches: { min: 11.81, max: 12 },
      mondo: { beginner: 31.5, advanced: 30.5 }
    },
    {
      inches: { min: 12, max: 12.2 },
      mondo: { beginner: 32.5, advanced: 31.5 }
    },
    {
      inches: { min: 12.2, max: 12.4 },
      mondo: { beginner: 32.5, advanced: 31.5 }
    },
    {
      inches: { min: 12.4, max: 12.59 },
      mondo: { beginner: 33.5, advanced: 32.5 }
    },
    {
      inches: { min: 12.59, max: 12.79 },
      mondo: { beginner: 33.5, advanced: 32.5 }
    },
    {
      inches: { min: 12.79, max: 13 },
      mondo: { beginner: 33.5, advanced: 33.5 }
    }
  ]
}

const footSizeOptions = [];
for (let i = 5.75; i <= 13; i += 0.25) {
  footSizeOptions.push({ name: i.toFixed(2) + ' in', value: i });
}

const globalsEmpty = {
  selections: {
    skillLevel: undefined,                       // [int] 1, 2 or 3
    runningShoeSize: '',                         // [string] -5 through 16. negatives are kids sizes
    dressShoeSize: '',                           // [string] -5 through 16. negatives are kids sizes
    sandalSize: '',                              // [string] -5 through 16. negatives are kids sizes
    leftFootSize: '',                            // [string] 5.75 - 13.00
    rightFootSize: '',                           // [string] 5.75 - 13.00
    
    finalShoeSize: undefined,                    // [float] -5 through 16. negatives are kids sizes
    finalFootSize: undefined,                    // [float] 5.75 - 13.00
  },
  currentSlide: 1,                               // 1 indexed to make life easier
  showSlide3: false,                             // dependent on shoe sizing case
  recommendedMondoSize: undefined,               // [string] 15.5 - 33.5
  recommendedBootType: '',                       // 'basic' or 'performance'
  originalRecBootType: '',                       // if primaryNotAvailableSecondaryAvailable this will be set to original boot recommendation
  bootUnavailable: false,                        // for case when boot is not available in recommended size and any style
  footSizeOutOfRange: false,                     // for case when recommendation based on foot size is out of range for user
  primaryNotAvailableSecondaryAvailable: false,  // for case when boot is not available in recommended style but is available in alternate style
}

let globals = JSON.parse(JSON.stringify(globalsEmpty));

/** 
 * STYLES
 * - modal width - ideally always trying to fill max possible width to prevent resize
 * - modal height - ideally always the same height but may not make sense in mobile.
 * 
 * nice to have: transition animations
 * - Button unlock
 * - button lock
 * - slide to slide
 *    - can either do a fade or a horizontal/vertical slide
 * - modal height/width if applicable
 * */

// --- HELPERS --------------------------------------------------------------------------

/** ### Resets the whole modal
 * 
 * Used when completing end step
 */
function resetFitFinder() {
  hideSlideRender();
  hideSlideNavEnd();
  hideBackButton();
  lockSlideNav();
  slide1();
  globals = JSON.parse(JSON.stringify(globalsEmpty));
}

/** ### For navigating backwards in the modal */
function prevSlide() {
  if (globals.currentSlide > 1) {
    if (globals.currentSlide === maxSlides) hideSlideNavEnd();
    hideSlideRender();
  } else return;

  switch (globals.currentSlide) {
    case 2:
      slide1();
      hideBackButton();
      break;
    case 3:
      slide2();
      break;
    case 4:
      globals.showSlide3 ? slide3() : slide2();
      break;
  }

  checkUnlockSlide();
}

/** ### For navigating forwards in teh modal */
function nextSlide() {
  if (globals.currentSlide <= maxSlides) {
    showBackButton();
    hideSlideRender();
  }

  switch (globals.currentSlide) {
    case 1:
      slide2();
      break;
    case 2:
      globals.showSlide3 ? slide3() : slideEnd();
      break;
    case 3:
      slideEnd();
      break;
  }

  if (globals.currentSlide === maxSlides) showSlideNavEnd();
  else checkUnlockSlide();
}

/** ### Check if slide can be unlocked and unlock it
 * 
 * - slide 1 unlocks with selection
 * 
 * - slide 2 unlocks with all fields filled
 * 
 * - slide 3 unlocks with all fields filled
 * 
 * Locks slide if values aren't filled. Also sets values in selections and showSlide3 based on logic
 */
function checkUnlockSlide() {
  switch (globals.currentSlide) {
    case 1:
      if (globals.selections.skillLevel !== undefined) {
        unlockSlideNav();
      } else lockSlideNav();
      break;
    case 2:
      if (globals.selections.runningShoeSize.length > 0
        && globals.selections.dressShoeSize.length > 0
        && globals.selections.sandalSize.length > 0) {
        const run = parseFloat(globals.selections.runningShoeSize)
        const dress = parseFloat(globals.selections.dressShoeSize)
        const sandal = parseFloat(globals.selections.sandalSize)
        
        globals.showSlide3 = false;
        if (run === sandal && dress === sandal) {
          globals.selections.finalShoeSize = parseFloat(run);
        } else if (sandal < run && sandal < dress) {
          globals.showSlide3 = true;
        } else {
          globals.selections.finalShoeSize = parseFloat(Math.min(run, dress) + 0.5);
        }
  
        unlockSlideNav();
      } else lockSlideNav();
      break;
    case 3:
      if (globals.selections.leftFootSize.length > 0
        && globals.selections.rightFootSize.length > 0) {
        const left = parseFloat(globals.selections.leftFootSize);
        const right = parseFloat(globals.selections.rightFootSize);
        globals.selections.finalFootSize = Math.max(left, right);
  
        unlockSlideNav();
      } else lockSlideNav();
      break;
  }
}

/** ### Close modal and reset fit finder */
function closeAndReset() {
  closeDialog(document.getElementById('fit-finder-modal'));
  setTimeout(resetFitFinder, 500);
}

// TODO: don't add size to default if selecting performance?
/** ### End step completion. Add values to product form and close modal
 * 
 * This also resets the modal.
 * 
 * Used only in success cases of end step
 * 
 * @param {string} type (optional) 'basicOnly' or undefined
 */
function addSizeToOrder(type) {
  defaultSelector.value = globals.recommendedMondoSize;
  if (type !== 'basicOnly' && (globals.recommendedBootType === 'performance' && hasAddon)) {
    addonSelector.value = globals.recommendedMondoSize;
    addonButton.click();
  }
  
  closeAndReset();
}

/** ### Remove `content-container` to make room for next slide elements */
function hideSlideRender() {
  modalSlideContent.find('.content-container').remove();
}

/** ### duh... */
function hideBackButton() {
  modalNavBack.addClass('hidden');
}

/** ### duh... */
function showBackButton() {
  modalNavBack.removeClass('hidden');
}

/** ### Locks the `Continue` button */
function lockSlideNav() {
  modalNavContinue.prop('disabled', true).prop('title', 'form incomplete').text('Form Incomplete');
}

/** ### Unlocks the `Continue` button */
function unlockSlideNav() {
  modalNavContinue.prop('disabled', false).prop('title', 'continue').text('Continue');
}

/** ### Hides all buttons related to the end step and shows `continue` button */
function hideSlideNavEnd() {
  modalNavContinue.removeClass('hidden');
  modalNavAddMySize.addClass('hidden');
  modalNavDone.addClass('hidden');
  modalNavRow2.addClass('hidden');
}

/** ### Decides on what to display in end-step nav
 * 
 * Based on boot availability
 */
function showSlideNavEnd() {    
  modalNavContinue.addClass('hidden');
  if (globals.primaryNotAvailableSecondaryAvailable) {
    // if boot is in range but only available in alternate style
    modalNavAddMySize.removeClass('hidden');
    modalSlideTitle.innerText = `Your ideal boot is a ${globals.originalRecBootType} ski boot, but unfortunately we don't have your size in stock.`;
    modalSlideSubtitle.empty().append($(`<div>We do have your size in stock in a <strong>${globals.recommendedBootType}</strong> ski boot, so that's our recommendation for you today!</div>`));
  } else if (globals.bootUnavailable) {
    // if boot is in range but unavailable in all styles
    modalNavDone.removeClass('hidden');
    modalSlideTitle.innerText = `Oh no, we're out of stock in your size!`;
    modalSlideSubtitle.empty().append($(`<div>Don't worry - our rental staff will still be able to help. <br><a href="/blogs/stores" class="h5 font-bold underline cursor-pointer hover:brightness-90" title="Check out our stores">Come visit us</a> or <a title="Video chat with an expert" aria-label="Video chat with an expert" href="/pages/online-outfitting" class="h5 font-bold underline cursor-pointer hover:brightness-90">video chat an expert</a></div></div>`));
  } else if (globals.footSizeOutOfRange) {
    // if boot is out of range
    modalNavDone.removeClass('hidden');
    modalSlideTitle.innerText = `Your ideal boot is a ${globals.recommendedMondoSize}, but unfortunately that size is outside of the range we carry for ${getBootGender()} ${globals.recommendedBootType} ski boots.`;
    modalSlideSubtitle.empty().append($(`<div>Please <a href="/blogs/stores" class="h5 font-bold underline cursor-pointer hover:brightness-90" title="Check out our stores" aria-label="Check out our stores">come into your local store</a> or <a title="Video chat with an expert" aria-label="Video chat with an expert" href="/pages/online-outfitting" class="h5 font-bold underline cursor-pointer hover:brightness-90">video chat an expert</a> for one-on-one help!</div>`));
  } else {
    // if boot is available
    modalSlideTitle.innerText = `Based on your data, we recommend:`;
    modalSlideSubtitle.empty().text('');  
    modalNavAddMySize.removeClass('hidden');
    if (defaultBootType !== 'performance' && globals.recommendedBootType === 'performance') modalNavRow2.removeClass('hidden');
  }
}

/** ### Sets `recommendedMondoSize`
 * 
 * Outcomes:
 * 1. size is in range - check skill level and assign size rec
 * 2. size is out of range - check skill level and assign size rec but set error case true
 * 3. [none of the above] error case - set size rec to empty string
 */
function decideSize() {
  const sizing = globals.selections.finalFootSize
  ? sizingChart[gender].find(e => e.inches.min <= globals.selections.finalFootSize && globals.selections.finalFootSize <= e.inches.max)
  : globals.selections.finalShoeSize
    ? sizingChart[gender].find(e => e.shoe === globals.selections.finalShoeSize)
    : null;

  globals.recommendedMondoSize = sizing 
  ? ((globals.selections.skillLevel === 1 || sizing.mondo.advanced === null) 
    ? sizing.mondo.beginner 
    : sizing.mondo.advanced) 
  : undefined;
  
  globals.footSizeOutOfRange = false;
  if (globals.recommendedMondoSize === undefined) {
    globals.footSizeOutOfRange = true;
    const outOfRangeSizing = sizingChart.all.find(e => e.inches.min <= globals.selections.finalFootSize && globals.selections.finalFootSize <= e.inches.max);
    globals.recommendedMondoSize = outOfRangeSizing
    ? ((globals.selections.skillLevel === 1 || outOfRangeSizing.mondo.advanced === null)
      ? outOfRangeSizing.mondo.beginner
      : outOfRangeSizing.mondo.advanced)
    : '';
  }
}

/** ### Check and return recommended size availability
 * 
 * Find selectors' options based on recommended size and checks whether they're disabled or not.
 * 
 * - If disabled or option doesn't exist, set true
 * - If exists and is selectable, set false
 * 
 * @returns {{default: {Boolean}, addon: {Boolean}}}
 */
function checkSizeNotAvailable() {
  const option = defaultSelector.querySelector(`option[value="${globals.recommendedMondoSize}"]`);
  const addonOption = hasAddon ? addonSelector.querySelector(`option[value="${globals.recommendedMondoSize}"]`) : undefined;

  const availability = {
    default: option ? option.disabled : true,
    addon: addonOption ? addonOption.disabled : true,
  }
  
  return availability;
}

/** ### Sets `recommendedBootType`
 * 
 * Covers cases for:
 * - primary rec available
 * - primary rec unavailable, secondary rec available
 * - no rec available
 */
function decideBootType() {  
  const notAvailable = checkSizeNotAvailable();
  globals.bootUnavailable = false;
  globals.primaryNotAvailableSecondaryAvailable = false;

  if (!hasAddon) {
    // default boot is performance boot OR default boot is basic and doesn't have an addon
    globals.recommendedBootType = defaultBootType;
    modalSlideTitle.innerText = notAvailable.default;
  } else {
    // default boot is basic boot AND has addon performance boot option
    if (globals.selections.skillLevel === 1) {
      // if beginner recommend basic
      globals.recommendedBootType = 'basic';
      globals.originalRecBootType = 'basic';
      if (notAvailable.default && notAvailable.addon) {
        // if default and addon not available
        globals.bootUnavailable = true;
        globals.primaryNotAvailableSecondaryAvailable = false;
      } else if (notAvailable.default && !notAvailable.addon) {
        // else if only addon available recommend performance
        globals.bootUnavailable = false;
        globals.primaryNotAvailableSecondaryAvailable = true;
        globals.recommendedBootType = 'performance';
      }
    } else {
      // if intermediate or advance recommend performance
      globals.recommendedBootType = 'performance';
      globals.originalRecBootType = 'performance';
      if (notAvailable.default && notAvailable.addon) {
        // if default and addon not available
        globals.bootUnavailable = true;
        globals.primaryNotAvailableSecondaryAvailable = false;
      } else if (notAvailable.addon && !notAvailable.default) {
        // else if only default is available recommend basic
        globals.bootUnavailable = false;
        globals.primaryNotAvailableSecondaryAvailable = true;
        globals.recommendedBootType = 'basic';
      }
    }
  }
}

/** ### Translates gender from tags to usable string values */
function getBootGender() {
  switch (gender) {
    case 'mens':
      return `men's`;
    case 'womens':
      return `women's`;
    case 'junior':
      return `kids'`;
    default:
      return '';
  }
}

/** ### Adds in upsell price to Add button in addon case */
function setAddonPrice() {
  let values = $(addonPrice).clone().find('small').remove().end().text().trim().split('-');
  let formattedAddonPrice = values.map(value => "$" + parseInt(value.trim())).join('-');
  modalNavAddMySize.text(`${modalNavAddMySizeText} (+${formattedAddonPrice})`);
}

/** ### Removes upsell price from Add button */
function resetAddonButtonText() {
  modalNavAddMySize.text(modalNavAddMySizeText);
}

// --- COMPONENTS -----------------------------------------------------------------------
/** ### [Component] Create a skill tile radio button jQuery object
 * 
 * Used in slide1
 * 
 * @param {number} level used for setting skill level. 1, 2, or 3
 * @param {string} icon circle, square, or diamond
 * @param {string} name title text
 * @param {string} color green, blue, or black
 * @param {string} message body text
 * @returns jQuery object
 */
function skillTile(level, icon, name, color, message) {
  const id = name.toLowerCase().replaceAll(' ', '-');
  const checked = globals.selections.skillLevel === level;

  const tile = $(`<div id="${id}" class="skill-tile-wrapper cursor-pointer" data-value="${level}">
    <label class="hidden">${name} option selector</label>
    <input id="option${level}" name="skill-level" class="hidden" type="radio" ${checked ? 'checked' : ''}>
    </input>
    <div class="skill-tile outline-sb-${color} h-full border border-sb-grey-400" data-radio="option${level}">
      <div class="h4 m-0 font-bold border-b border-sb-grey-400 text-sb-${color} py-6 flex justify-center items-center gap-3"><i class="${icon}"></i> ${name}</div>
      <div class="py-8 px-12 flex justify-center items-center text-center">${message}</div>
    </div>
  </div>`);

  tile.on('click tap', (e) => {
    $(e.currentTarget).find('input').prop('checked', true);
    unlockSlideNav();
    globals.selections.skillLevel = level;
  });

  return tile;
}

/** ### [Component] Generates container to hold radio button tiles
 * 
 * Tiles:
 * - beginner
 * - intermediate
 * - advanced
 * @returns jQuery object
 */
function tilesContainer() {
  const container = $('<div class="content-container grid grid-cols-1 lg:grid-cols-3 gap-4"></div>');
  container.append(skillTile(1, 'sb-icon-circle', 'beginner skier', 'green', 'Skied maybe 3 times before (or never!), planning to stick to the green runs'));
  container.append(skillTile(2, 'sb-icon-square', 'intermediate skier', 'blue', 'Skis once or twice a year, feels comfortable on blue runs, and some black diamonds'));
  container.append(skillTile(3, 'sb-icon-diamond', 'advanced skier', 'grey-900', 'Skis 3+ times per year, is comfortable on black diamond runs and above'));

  return container;
}

/** ### [Component] Create option elements from a string array
 * @param {array} options option is an object with a name (what you see) and value (raw data)
 * @returns {string} string of html option elements
 */
function createOptions(options) {
  return options.map(({value, name}) => `<option value="${value}">${name}</option>`).join('');
}

/** ### [Component] Create a styled `<select>` jQuery object
 * 
 * Used in slides 2 and 3
 * 
 * @param {{ name: string, value: string}} placeholder 
 * @param {[{ name: string, value: number }]} data 
 * @param {string} selectionKey any selector key from `globals.selections`
 * @param {string} selectedValue what will be selected provided a value exists
 * @returns jQuery object
 */
function selector(placeholder, data, selectionKey, selectedValue = "") {
  let options = '';
  options = createOptions(data);

  const selector = $(`<div class="size-select-wrapper w-full relative">
    <select class="size-select">
      <option value="${placeholder.value}" selected>${placeholder.name}</option>
      ${options}
      </select>
      <div class="h-full flex items-center absolute right-0 top-0 pointer-events-none">
        <i class="sb-icon-chevron-down text-sb-grey-800 text-4xl pr-2"></i>
      </div>
  </div>`);

  const select = selector.find('select');
  
  select.val(selectedValue);
  select.on('change', (e) => {
    globals.selections[selectionKey] = e.target.value;
    checkUnlockSlide();
  });

  return selector;
}

/** ### [Component] Generates container to hold shoe selectors
 * 
 * Selectors:
 * - running shoe size
 * - dress shoe size
 * - sandal size
 * 
 * @returns jQuery object
 */
function shoeSelectorsContainer() {
  const container = $('<div class="content-container grid grid-cols-1 lg:grid-cols-3 gap-4"></div>');
  container.append(selector({ name: 'select running shoe size', value: '' }, shoeSizeOptions[gender], 'runningShoeSize', globals.selections.runningShoeSize));
  container.append(selector({ name: 'select dress shoe size', value: '' }, shoeSizeOptions[gender], 'dressShoeSize', globals.selections.dressShoeSize));
  container.append(selector({ name: 'select sandal size', value: '' }, shoeSizeOptions[gender], 'sandalSize', globals.selections.sandalSize));

  return container;
}

/** ### [Component] Generates container to hold foot size selectors
 * 
 * Selectors:
 * - left foot size
 * - right foot size
 * 
 * @returns jQuery object
 */
function footSizeSelectorsContainer() {
  const container = $('<div class="content-container grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-12"></div>');
  container.append(selector({ name: 'Left foot measurement', value: '' }, footSizeOptions, 'leftFootSize', globals.selections.leftFootSize));
  container.append(selector({ name: 'Right foot measurement', value: '' }, footSizeOptions, 'rightFootSize', globals.selections.rightFootSize));

  return container;
}

/** ### [Component] Generates container for sizing instructions
 * 
 * Has image and 4 steps of text
 * 
 * @returns jQuery object
 */
function footSizeInstructions() {
  const container = $(`<div class="content-container grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-12 pb-8">
    <img class="w-full" src="https://cdn.shopify.com/s/files/1/0751/7203/files/FitFinder_Foot.svg?v=1731089895" alt="Foot Sizing Graphic">
    <ol class="w-full max-w-sm md:max-w-none lg:max-w-sm pr-4 flex flex-col gap-4 text-left text-sb-grey-800" style="width: calc(100% - 0.5rem)">
      <li>Grab two pieces of paper and a pen and place the paper touching the wall.</li>
      <li>Stand against the wall in bare feet, with your heels touching the wall.</li>
      <li>Have a friend mark where your big toes end on the piece of paper.</li>
      <li>Measure the edge of the paper to your big toe mark in inches and enter your measurements below, rounding up!</li>
    </ol>
  </div>`);
  
  return container;
}

/** ### [Component] Generates container for final slide recommendation card
 * 
 * Dependent on:
 * - globals.recommendedBootType
 * - globals.recommendedMondoSize
 * - globals.footSizeOutOfRange
 * - getBootGender()
 * 
 * @returns jQuery object
 */
function recommendation() {
  const articleUri = "/blogs/news/ski-boot-fitting-a-step-by-step-guide";

  const container = $(`<div class="content-container inline-flex flex-col sm:flex-row gap-4 bg-white p-8 rounded-lg shadow-b-r">
  <div class="w-full sm:w-32 sm:h-32">
    <img src="${image[globals.recommendedBootType]}" heigh="128" width="128" alt="recommended boot image" class="w-full"/>
  </div>  
    <div class="flex flex-col text-left">
      <div class="h5 font-bold m-0">${getBootGender()} ${globals.recommendedBootType} ski boot</div>
      <div class="h4 font-bold mb-4 flex items-center gap-1">Size: ${globals.recommendedMondoSize}${globals.footSizeOutOfRange ? ` <i class="sb-icon-warning text-sb-yellow"></i>` : ``}</div>
      <a title="go to article" aria-label="go to article" class="text-sm underline hover:brightness-90 mt-auto" href="${articleUri}"><em>learn how we determine your size</em></a>
    </div>
  </div>`);

  return container;
}

// --- SLIDES ---------------------------------------------------------------------------

/** ### Render slide 1 
 * 
 * Skill level step
 */
function slide1() {
  globals.currentSlide = 1;
  modalSlideTitle.innerText = `Let's start with the basics. Are you a:`;
  modalSlideSubtitle.empty().text(``);
  modalSlideContent.append(tilesContainer());
}

/** ### Render slide 2
 * 
 * Shoe size step
 */
function slide2() {
  globals.currentSlide = 2;
  modalSlideTitle.innerText = `Great! What's your shoe size?`;
  modalSlideSubtitle.empty().text(`We ask for a few different shoe types to get a sense of your preferred fit.`);
  modalSlideContent.append(shoeSelectorsContainer());
}

/** ### Render slide 3
 * 
 * Foot size step
 */
function slide3() {
  globals.currentSlide = 3;
  modalSlideTitle.innerText = `Looks like you're between sizes. Let's measure you!`;
  modalSlideSubtitle.empty().text(`This is the size of most of your running shoes or dress shoes - not sandals or rain boots`);
  modalSlideContent.append(footSizeInstructions());
  modalSlideContent.append(footSizeSelectorsContainer());
}

/** ### Render slide End 
 * 
 * Recommend boot and give selection options
 */
function slideEnd() {
  globals.currentSlide = 4;
  decideSize();
  decideBootType();
  if (hasAddon && globals.recommendedBootType === 'performance') setAddonPrice();
  else resetAddonButtonText();

  modalSlideContent.append(recommendation());
}

// --- WATCHERS -------------------------------------------------------------------------
modalNavContinue.on('click tap', nextSlide);
modalNavBack.on('click tap', prevSlide);
modalNavAddMySize.on('click tap', addSizeToOrder);
modalNavAddMySizeBasicOnly.on('click tap', () => addSizeToOrder('basicOnly'));
modalNavDone.on('click tap', closeAndReset);
if (hasAddon && globals.recommendedBootType === 'performance') openButton.on('click tap', setAddonPrice);

// --- START ----------------------------------------------------------------------------

/** ### Run on load */
function initialize() {
  slide1();
}

initialize();